module.exports = __webpack_public_path__ + "img/point-of-contacts.10f55bca.png";